<template>
  <div class="post-content-box">
    <div id="post-editor-box" ref="editorElem"></div>
  </div>
</template>

<script>
// import wEditor from 'wangeditor'
import axios from 'axios'
import wEditor from '@/../static/js/wangeditor.js'
// import Qiniu from 'qiniu'
// import Qiniu from 'qiniu-js'
// import Qiniu from '@/../static/js/qiniu.js'
// var Qiniu = require('qiniu-js')
import * as qiniu from 'qiniu-js'

export default {
  name: 'post_content_cpn',
  props: ['catchData'],
  data () {
    return {
      editor: null,
      editorContent:''
    }
  },
  mounted() {
    this.initWEditor();
  },
  watch: {
    editor: function() {
  
    }
  },
  methods: {
    initWEditor: function() {
      let vm = this;
        vm.editor = new wEditor(this.$refs.editorElem);
        vm.editor.customConfig.onchange = (html) => {
            this.editorContent = html;
            this.catchData(html);  //内容发送给父组件
          }
          
          // 菜单栏
          vm.editor.customConfig.menus = [
            // 'head',     // 标题
            // 'bold',     // 粗体
            // 'italic',   // 斜体
            'image',    // 图片
            'video',    // 视频
            'emoticon'  // 表情
          ];


          // 菜单栏添加图片
          vm.editor.customConfig.uploadImgFileName = 'myFileName'; 
          vm.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
          vm.editor.customConfig.uploadImgMaxLength = 9;
          vm.editor.customConfig.debug = true;

          vm.editor.customConfig.customUploadImg = function(files,insert) {
            if (vm.checkFileSizeWithHint(files[0],1)) {
              return;
            }

            let param = new FormData();

            param.append("file",files[0],files[0].name);
            vm.$client.uploadPicture(param)
              .then((resp) => {
                if (resp.data.code == '200' || resp.data.code == 200) {
                  let picUrl = resp.data.data.url;
                  insert(picUrl);
                }
              }).catch((err) => {
              })
          };

          vm.editor.customConfig.customUploadVideo = function(files) {    
            
            if (vm.checkFileSizeWithHint(files[0],20)) {
              return;
            }

            vm.reqQiNiuToken(files);
          };

          vm.editor.create();
    },
    checkFileSizeWithHint: function(file,maxSize) {
      let maxs = maxSize * 1024 * 1014;
      let fileSize = file.size;
      let isMaxFile = false;

      if (fileSize > maxs) {
        isMaxFile = true;
        this.$elementMsg.warning({
          'message': '上传文件大小不超过'+ maxSize +'M',
          'showClose':true,
          'customClass': 'pop-class-warning',
          'duration': 3000
        })
      }

      return isMaxFile;
    },
    reqQiNiuToken: function(files) {
      let vm = this;
      let typeObj = {
        'type': 'course_video'
      }
      this.$client.requestQiNiuToken(typeObj)
        .then((resp) => {
          vm.uploadVideoToQiNiu(files[0],resp.data.uptoken);
        }).catch((err) => {
  
        })
    },
    uploadVideoToQiNiu(imgSource,token) {
      let vm = this;
      const file = imgSource    //Blob 对象，上传的文件
      const key = null          // 上传后文件资源名以设置的 key 为主，如果 key 为 null 或者 undefined，则文件资源名会以 hash 值作为资源名。

      let config = {
        useCdnDomain: true,         //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
        region: qiniu.region.z0     // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
      };

      let putExtra = {
        fname: "",        // 文件原文件名
        params: {},       // 用来放置自定义变量
        mimeType: null    // 用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
      };

      let observable = qiniu.upload(file, key, token, putExtra, config);

      observable.subscribe({
        next: (res) => {
        // 主要用来展示进度
          let total = res.total;
        },
        error: (err) => {
        // 失败报错信息
        },
        complete: (res) => {
          vm.editor.cmd.do('insertHTML', '<video class="post-video" src="http://p0rwwxijh.bkt.clouddn.com/'+ res.key + '" style="max-width: 65%;" controls autobuffer />');
        }
      })
    }
  }
}
</script>

<style lang="less">
  .post-content-box {
    overflow: hidden;
    height: 100%;
    border: 1px solid #ccc;
    border-radius: 10px; 
    #post-editor-box {
      height: 100%;
      .w-e-toolbar {
        display: flex;
        height: 50px;
        padding-right: 35px;
        justify-content: flex-end;
        align-items: center;
        border: 0!important;
        .w-e-menu {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
          width: 34px;
          height: 34px;
          margin-left: 23px;
          &>i {
            display: block;
            width: 100%;
            height: 100%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          &>i::before {
            display: none;
          }
          .w-e-droplist {
            margin-top: 50px;
          }
        }
        .w-e-menu:nth-child(1) {
          &>i {
            background-image: url("../../assets/forum/picture_icon.png");
          }
        }
        .w-e-menu:nth-child(2) {
          &>i {
            background-image: url("../../assets/forum/video_icon.png");
          }
        }
        .w-e-menu:nth-child(3) {
          &>i {
            background-image: url("../../assets/forum/expression_icon.png");
          }
        }
      }
      .w-e-text-container {
        overflow: hidden;
        position: relative;
        height: 204px!important;
        border: 0!important;
        padding-right: 17px;
        .w-e-text {
          position: absolute;
          top: 0;
          width: 100%;
          right: -21px;
          padding: 0 17px 0 0;
        }
        .w-e-panel-container {
          color: #555;
          .w-e-panel-tab-content {
            max-height: 150px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/post_message/post_content_cpn.vue